<template>
  <div class="anno-altsidebar">
    <b-field label="Label Type">
      <label-type-selector />
    </b-field>
  </div>
</template>

<script>
import LabelTypeSelector from "@/components/LabelTypeSelector";

export default {
  name: "AnnotatorAltSidebar",
  components: {
    LabelTypeSelector
  }
};
</script>

<style lang="scss" scoped>
.anno-altsidebar {
  height: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 10px $border-grey;
  overflow-y: auto;
}
</style>
